/**
 * Fire a GA4 event if analytics is loaded (i.e. the visitor consented).
 * Safe no-op otherwise.
 */
export function track(event: string, params?: Record<string, string>) {
  try {
    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
    if (w.gtag) w.gtag('event', event, params || {});
  } catch {
    /* never break the page for analytics */
  }
}
